import { truncateText } from 'app/shared/utils/general';
import { Badge } from 'app/shared/badge';

export const table_config = (permissions) => {
  return {
    actions: {
      bulk: [
        [
          {
            value: 'add_to_audience',
            label: 'Add to audience',
            hidden: !permissions['contact:update']
          },
          { value: 'assign_tag', label: 'Assign Tags', hidden: !permissions['contact:update'] }
        ],
        [
          {
            color: 'red',
            value: 'delete',
            label: 'Delete',
            hidden: !permissions['contact:delete']
          }
        ]
      ],
      single: (contact) => [
        [
          {
            value: 'add_to_audience',
            label: 'Add to audience',
            hidden: !permissions['contact:update']
          },
          {
            value: 'mark_as_valid',
            label: 'Mark as valid',
            hidden: !!contact.is_valid || !permissions['contact:update']
          },
          { value: 'manage_tag', label: 'Manage Tags', hidden: !permissions['contact:update'] },
          { value: 'trigger_event', label: 'Trigger Event' }
        ],
        [{ color: 'red', value: 'delete', label: 'Delete', hidden: !permissions['contact:delete'] }]
      ]
    },
    allow_bulk_action: true,
    css: {},
    fields: [
      {
        title: 'First name',
        sortable: true,
        key: 'firstname',
        isTitle: true
      },
      {
        title: 'Last name',
        sortable: true,
        key: 'lastname',
        isTitle: true
      },
      {
        title: 'Email',
        key: 'email',
        sortable: true,
        isTagline: true,
        formatter: (value) => {
          return truncateText(value, 35) || 'V/A';
        }
      },
      {
        title: 'Status',
        sortable: true,
        key: 'is_valid',
        formatter: (value) => {
          let type = 'green';
          switch (value) {
            case true:
              type = 'green';
              value = 'valid';
              break;
            case false:
              type = 'red';
              value = 'invalid';
              break;
          }
          return <Badge type={type} text={value} />;
        }
      },
      {
        title: 'Date added',
        sortable: true,
        key: 'created_on',
        formatter: (value) => {
          return value ? new Date(value).toDateString() : '';
        },
        isMetadata: true
      }
    ],
    items: [],
    // Page size used for the request, footer count, and pagination. Must match
    // the population default in list.js handleDataRequest/handleSearchRequest.
    num_of_rows: 10,
    // search_key: 'name',
    search_text: ''
  };
};
